<template>
  <div class="selection-detail" v-if="detailInfo">
    <img class="top-img" :src="detailInfo.topic.picUrl" alt="" srcset="">
    <div class="detail-box">
      <div class="detail-title">{{detailInfo.topic.title}}</div>
      <div class="detail-text">{{detailInfo.topic.subtitle}}</div>
    </div>

    <div v-if="detailInfo" class="sel-content" v-html="detailInfo.topic.content"></div>
    <div class="comment-title">
      <div class="c-title-text"> <img class="pinglun" src="../../assets/index/pinglun_icon.png" alt="" srcset=""> 精选留言</div>
      <!-- <van-icon class="input-prew" @click="navCommentPost" name="edit" /> -->
      <div class="insert-text" @click="navCommentPost">
        <img class="input-icon" src="../../assets/index/input_icon.png" alt="" srcset="">
        写评论
      </div>
    </div>

    <div class="item-box">
      <div class="line"></div>
      <van-row class="list" v-if="commentListData.length != 0">
        <div class="comment-item" v-for="(item,index) in commentListData" :key="index">
          <div class="comment-item-top">
            <div class="comment-item-name">
              <img :src="item.userInfo.avatarUrl" alt="">
              <div class="item-name">{{item.userInfo.nickName}}</div>

            </div>
            <div class="comment-item-tiem">{{item.addTime}}</div>
          </div>
          <div class="comment-item-content">{{item.content}}</div>
          <div class="comment-img">
            <van-grid :column-num="4" :gutter="5">
              <van-grid-item v-for="(img,idx) in item.picList" :key="idx" @click="showImgs(item.picList,idx)" :icon="img" text="" />
            </van-grid>
          </div>
        </div>
      </van-row>
      <div v-else class="no-message">暂无评价</div>
    </div>
    <div class="more" @click="onLoad" v-if="!finished && commentListData.length != 0">查看更多</div>

    <!-- <div class="recommend">专题推荐</div>
    <div v-for="(item,index) in topicRelatedInfo" :key="index" class="special" @click="navToDetail(item.id)">
      <img :src="item.picUrl">
      <p>{{item.title}}</p>

    </div> -->
  </div>
</template>

<script>
import {
  topicDetail,
  commentList,
  topicRelated,
  // commentPost
} from "@/api/index";
import { Dialog, ImagePreview } from "vant";

export default {
  name: "featureSelection",
  components: {
    ImagePreview,
  },
  data() {
    return {
      detailInfo: null,
      topicRelatedInfo: "",
      commentListData: [],
      isLoading: true,
      loading: false,
      finished: false,
      featureData: {
        valueId: this.$route.query.id, //	专题id	是	[string]	316	查看
        type: 1, //	类型	是	[string]	1	查看
        showType: 0, //	显示类型	是	[string]	0	查看
        page: 1, //	页码	是	[string]	1	查看
        size: 10, //	页数	是	[string]	5
      },
    };
  },
  mounted() {
    topicDetail(this.$route.query.id).then((res) => {
      if (res.data.errno == 0) {
        this.detailInfo = res.data.data;
      } else {
        Dialog.alert({
          title: "提示",
          message: res.data.errmsg,
        });
      }
    });
    this.getCommentList(this.featureData);
    topicRelated(this.$route.query.id).then((res) => {
      if (res.data.errno == 0) {
        this.topicRelatedInfo = res.data.data;
      } else {
        Dialog.alert({
          title: "提示",
          message: res.data.errmsg,
        });
      }
    });
  },
  methods: {
    showImgs(list, idx) {
      ImagePreview({
        images: list,
        startPosition: idx,
        onClose() {
          // do something
        },
      });
    },
    onLoad() {
      setTimeout(() => {
        // 异步更新数据
        const nextPaging = {
          valueId: this.$route.query.id, //	专题id	是	[string]	316	查看
          type: 1, //	类型	是	[string]	1	查看
          showType: 0, //	显示类型	是	[string]	0	查看
          size: 10,
          page: this.featureData.page + 1, //	页码	是	[string]	1	查看
        };
        this.featureData = nextPaging;
        this.getCommentList(this.featureData);
      }, 500);
    },
    getCommentList(data) {
      commentList(data).then((res) => {
        if (res.data.errno == 0) {
          let newOfRes = JSON.parse(JSON.stringify(res.data.data));
          this.commentListData = this.commentListData.concat(newOfRes.data);
          console.log(this.commentListData);
          this.loading = false;
          console.log(this.featureData.page);
          console.log(res);
          console.log(this.finished);
          if (this.commentListData.length == newOfRes.count) {
            this.finished = true;
          }
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          });
        }
      });
    },
    navCommentPost() {
      this.$router.push({
        path: "/commentPage",
        query: {
          info: JSON.stringify(this.detailInfo),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.selection-detail {
  height: 100%;
  background: #f4f4f4;
  overflow-y: scroll;
  // padding-bottom: 5rem;
  box-sizing: border-box;
  overflow-x: hidden;
  .top-img {
    width: auto;
    height: 17.1rem;
  }
  .detail-box {
    background: #fff;
    padding: 1rem;

    .detail-title {
      text-align: left;
      font-family: PingFangSC-Semibold;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.4rem;
    }
    .detail-text {
      text-align: left;
      margin: 1rem 0;

      opacity: 0.5;
      font-family: PingFangSC-Regular;
      font-size: 1.2rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.2rem;
    }
  }

  .sel-content {
    padding: 0 1.6rem;
    width: 100%;
    background: #fff;
    box-sizing: border-box;
    margin-bottom: 1rem;
    /deep/ p {
      margin: 0;
      margin: 0;
      text-align: left;
      padding-bottom: 1rem;
      img {
        height: auto;
        width: 100%;
      }
    }
  }

  .comment-title {
    height: 4.65rem;
    display: flex;
    background: #fff;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 1.6rem;
    margin: 1px auto 0;
    box-sizing: border-box;
    // border-bottom: 1px solid #999;
    .c-title-text {
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.4rem;
      display: flex;
      align-items: center;
      .pinglun {
        width: 2rem;
        height: 2rem;
        margin-right: 0.6rem;
      }
    }
    .insert-text {
      display: flex;
      align-items: center;
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #a0a0a0;
      letter-spacing: 0;
      line-height: 1.4rem;
      .input-icon {
        width: 1.6rem;
        height: 1.6rem;
        margin-right: 0.4rem;
      }
    }
  }
  .item-box {
    width: 100%;
    background: #fff;
    min-height: 3rem;
    height: auto;
    padding: 0 1.6rem 3rem;
    box-sizing: border-box;

    .line {
      opacity: 0.3;
      border-top: 1px solid #c2c2c2;
      width: 100%;
      margin: 0 auto 2.05rem;
    }
    .no-message {
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      text-align: justify;
      line-height: 1.8rem;
      width: 100%;
      text-align: left;
    }
  }

  .comment-item {
    height: auto;
    width: 90%;
    margin: 0 auto;
    padding: 1rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid #eee;
    .comment-item-top {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .comment-item-name {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        img {
          width: 3.2rem;
          height: 3.2rem;
          border-radius: 100%;
          margin-right: 1rem;
        }
        .item-name {
          font-family: PingFangSC-Semibold;
          font-size: 1.4rem;
          color: #424242;
          line-height: 1.4rem;
        }
        .comment-item-tiem {
          opacity: 0.5;
          font-family: PingFangSC-Regular;
          font-size: 1.2rem;
          color: #424242;
          text-align: right;
          line-height: 1.2rem;
        }
      }
    }
    .comment-item-content {
      width: 100%;
      text-align: left;
      margin-top: 1rem;
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      text-align: justify;
      line-height: 1.8rem;
    }
    .comment-img {
      width: 100%;
      height: auto;
      text-align: left;
      margin-top: 1rem;
      img {
        width: 8rem;
        height: 8rem;
        margin-right: 0.5rem;
      }
    }
  }
  .recommend {
    margin: 1rem 0;
    font-size: 1.6rem;
    color: #999;
  }
  .special {
    width: 100%;
    background: #fff;
    padding-bottom: 1rem;
    // margin-top: 2rem;
    .special-title {
      width: 100%;
      height: 4rem;
      line-height: 4rem;
      font-size: 16px;
      span {
        float: right;
        margin-right: 1rem;
      }
    }
    p {
      width: 96%;
      text-align: left;
      font-size: 1.4rem;
      margin: 0.5rem auto;
    }
    span {
      margin-left: 2rem;
    }
    img {
      width: 96%;
    }
    .special-sub {
      color: orange;
      font-size: 1.4rem;
    }
  }
}
.more {
  margin: 1rem 0;
  font-size: 1.4rem;
}
/deep/ .van-grid-item__content--center {
  padding: 0;
  height: 8rem;
  overflow: hidden;
}
/deep/ .van-icon__image {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/index/featureDetail.vue